<template>
  <div></div>
</template>

<script>
export default {
  mounted() {
    this.$router.push({ name: "TermsOfServiceScreen" }).catch((err) => {});
  },
};
</script>

<style>
</style>